package com.essntl.uikit

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.dateDiffInDays

@Composable
fun <T, D> rememberEquals(
    item: T,
    selectedIds: Set<D>?,
    idSelector: (T) -> D,
): Boolean {
    return remember(
        item,
        selectedIds,
    ) {
        idSelector(item) in selectedIds.orEmpty()
    }
}

@Composable
fun <T, D> rememberContains(
    items: List<T>,
    selectedIds: Set<D>?,
    idSelector: (T) -> D,
): List<T> {
    return remember(
        items,
        selectedIds,
    ) {
        items.filter { idSelector(it) in selectedIds.orEmpty() }
    }
}

@Composable
fun <T, D> rememberFind(
    items: List<T>,
    id: D,
    defaultValue: T,
    idSelector: (T) -> D,
): T {
    return remember(items, id) {
        items
            .find {
                idSelector(it) == id
            }
            ?: defaultValue
    }
}

@Composable
fun <T, D> rememberFind(
    items: List<T>,
    id: D,
    idSelector: (T) -> D,
): T? {
    return remember(items, id) {
        items.find {
            idSelector(it) == id
        }
    }
}

@Composable
fun rememberNumberOfDaysPrettyString(
    fromDate: String?,
    toDate: String?,
): String {
    return remember(fromDate, toDate) {
        val diff = dateDiffInDays(
            fromDate = fromDate,
            toDate = toDate,
        )?.plus(1)

        if (diff == null)
            ""
        else if (diff <= 1)
            "$diff day"
        else
            "$diff days"
    }
}

@Composable
fun rememberNumberOfDays(
    fromDate: String?,
    toDate: String?,
): Int? {
    return remember(fromDate, toDate) {
        dateDiffInDays(
            fromDate = fromDate,
            toDate = toDate,
        )?.plus(1)
    }
}